module.exports = __webpack_public_path__ + "img/stk.db8cadb0.png";